import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {NumberStepConfig, NumberStepConfigJson} from './number-step-config';

export type TimeStepSizeConfigJson = {
  labels: Array<NumberStepConfigJson>;
  lines: Array<NumberStepConfigJson>;
};

export class TimeStepSizeConfig implements JsonConfigInterface<TimeStepSizeConfigJson> {

  private _labels: Array<NumberStepConfig> = [];
  private _lines: Array<NumberStepConfig> = [];

  constructor(json?: TimeStepSizeConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get labels(): Array<NumberStepConfig> {
    return this._labels;
  }

  public get lines(): Array<NumberStepConfig> {
    return this._lines;
  }

  public deserializeJson(json: TimeStepSizeConfigJson): void {
    this._labels = json.labels.map(value => new NumberStepConfig(value));
    this._lines = json.lines.map(value => new NumberStepConfig(value));
  }
}
